import Anketa from './Anketa.vue';
export default Anketa;



// WEBPACK FOOTER //
// ./src/components/anketa/index.ts